import { createSelector } from 'reselect';

const selectDomain = (state) => state.card;

export const selectCard = createSelector(
  [selectDomain], (state) => state.get('card'),
);